import { ExternalSystemType } from '@/graphql/generated/schemas'

export const CAMERA_SECRET_TEMPLATE = { rtspUsername: '', rtspPassword: '' }

export const PACS_SECRET_TEMPLATE = { username: '', password: '' }

export const EXTERNAL_ACCOUNT_SECRET_TEMPLATES: Record<
  ExternalSystemType,
  Record<string, string>
> = {
  // Arcules cloud (step-1 slice; backend enablement ENG-32227): the login
  // email/password IS the credential — Arcules
  // has no vendor API keys; one credential serves live + historical. region US | EU | JP
  // selects msapi.arcules.com / -eu / -jp. No org-id key — org_id comes from the token
  // claim (ENG-32206).
  [ExternalSystemType.Arcules]: {
    email: '',
    password: '',
    region: '',
  },
  [ExternalSystemType.ExacqvisionOnprem]: { username: '', password: '' },
  [ExternalSystemType.Ava]: {
    username: '',
    password: '',
    organization: '',
    region: '',
    url: '',
  },
  [ExternalSystemType.Avigilon]: {
    username: '',
    password: '',
    nonce: '',
    key: '',
    api_url: '',
    enable_ssl_check: '',
  },
  [ExternalSystemType.Verkada]: {
    api_key: '',
    expiration: '',
    permission: '',
  },
  // Lumana cloud (ENG-31639): shared secret shape decided on ENG-31634/ENG-31636 —
  // the API base URL rides in the secret, no per-account properties row.
  [ExternalSystemType.Lumana]: {
    api_key: '',
    api_url: '',
  },
}

export const formatSecretTemplate = (obj: Record<string, string>): string =>
  JSON.stringify(obj, null, 2)
